// extracted by mini-css-extract-plugin
export var danger = "_45-6";
export var lightPink = "_45-a";
export var medium = "_45-j";
export var nearSquare = "_45-m";
export var neutralBlue = "_45-8";
export var neutralYellow = "_45-7";
export var noCapitalize = "_45-1";
export var normal = "_45-2";
export var pill = "_45-0";
export var primary = "_45-3";
export var primaryLight = "_45-4";
export var shadow = "_45-n";
export var small = "_45-k";
export var solidBlack = "_45-i";
export var solidGreen = "_45-d";
export var solidLightBlue = "_45-f";
export var solidNavy = "_45-e";
export var solidOrange = "_45-h";
export var solidPink = "_45-g";
export var solidRed = "_45-b";
export var solidWhite = "_45-9";
export var solidYellow = "_45-c";
export var success = "_45-5";
export var xsmall = "_45-l";